exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#discardTable[data-v-68e5c650] input[type=\"number\"]::-webkit-inner-spin-button,\n#discardTable[data-v-68e5c650] input[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n", ""]);

// exports
